/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI BMAW
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  SmartProblemDetails,
  TextTranslationRequest,
} from '../models/index';
import {
    SmartProblemDetailsFromJSON,
    SmartProblemDetailsToJSON,
    TextTranslationRequestFromJSON,
    TextTranslationRequestToJSON,
} from '../models/index';

export interface TranslatorCancelTranslationPostRequest {
    processId?: string;
}

export interface TranslatorTranslateFilePostRequest {
    processId?: string;
    fileName?: string;
    glossaryId?: string;
    sourceLanguageCode?: string;
    targetLanguageCode?: string;
    fileSizeInBytes?: number;
}

export interface TranslatorTranslateTextPostRequest {
    processId?: string;
    sourceLanguageCode?: string;
    targetLanguageCode?: string;
    textTranslationRequest?: TextTranslationRequest;
}

export interface TranslatorTranslateWithGlossaryTextPostRequest {
    processId?: string;
    glossaryId?: string;
    sourceLanguageCode?: string;
    targetLanguageCode?: string;
    body?: string;
}

/**
 * 
 */
export class TranslatorApi extends runtime.BaseAPI {

    /**
     */
    async translatorCancelTranslationPostRaw(requestParameters: TranslatorCancelTranslationPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['processId'] != null) {
            headerParameters['processId'] = String(requestParameters['processId']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://40740436-0f46-43d8-86f5-e2cb999feec6/access_as_user"]);
        }


        let urlPath = `/api/Translator/CancelTranslation`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async translatorCancelTranslationPost(requestParameters: TranslatorCancelTranslationPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.translatorCancelTranslationPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async translatorTranslateFilePostRaw(requestParameters: TranslatorTranslateFilePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['processId'] != null) {
            headerParameters['processId'] = String(requestParameters['processId']);
        }

        if (requestParameters['fileName'] != null) {
            headerParameters['fileName'] = String(requestParameters['fileName']);
        }

        if (requestParameters['glossaryId'] != null) {
            headerParameters['glossaryId'] = String(requestParameters['glossaryId']);
        }

        if (requestParameters['sourceLanguageCode'] != null) {
            headerParameters['sourceLanguageCode'] = String(requestParameters['sourceLanguageCode']);
        }

        if (requestParameters['targetLanguageCode'] != null) {
            headerParameters['targetLanguageCode'] = String(requestParameters['targetLanguageCode']);
        }

        if (requestParameters['fileSizeInBytes'] != null) {
            headerParameters['fileSizeInBytes'] = String(requestParameters['fileSizeInBytes']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://40740436-0f46-43d8-86f5-e2cb999feec6/access_as_user"]);
        }


        let urlPath = `/api/Translator/TranslateFile`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async translatorTranslateFilePost(requestParameters: TranslatorTranslateFilePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.translatorTranslateFilePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async translatorTranslateTextPostRaw(requestParameters: TranslatorTranslateTextPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['processId'] != null) {
            headerParameters['processId'] = String(requestParameters['processId']);
        }

        if (requestParameters['sourceLanguageCode'] != null) {
            headerParameters['sourceLanguageCode'] = String(requestParameters['sourceLanguageCode']);
        }

        if (requestParameters['targetLanguageCode'] != null) {
            headerParameters['targetLanguageCode'] = String(requestParameters['targetLanguageCode']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://40740436-0f46-43d8-86f5-e2cb999feec6/access_as_user"]);
        }


        let urlPath = `/api/Translator/TranslateText`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TextTranslationRequestToJSON(requestParameters['textTranslationRequest']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async translatorTranslateTextPost(requestParameters: TranslatorTranslateTextPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.translatorTranslateTextPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async translatorTranslateWithGlossaryTextPostRaw(requestParameters: TranslatorTranslateWithGlossaryTextPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['processId'] != null) {
            headerParameters['processId'] = String(requestParameters['processId']);
        }

        if (requestParameters['glossaryId'] != null) {
            headerParameters['glossaryId'] = String(requestParameters['glossaryId']);
        }

        if (requestParameters['sourceLanguageCode'] != null) {
            headerParameters['sourceLanguageCode'] = String(requestParameters['sourceLanguageCode']);
        }

        if (requestParameters['targetLanguageCode'] != null) {
            headerParameters['targetLanguageCode'] = String(requestParameters['targetLanguageCode']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://40740436-0f46-43d8-86f5-e2cb999feec6/access_as_user"]);
        }


        let urlPath = `/api/Translator/TranslateTextWithGlossary`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async translatorTranslateWithGlossaryTextPost(requestParameters: TranslatorTranslateWithGlossaryTextPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.translatorTranslateWithGlossaryTextPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
